export default __webpack_public_path__ + "static/media/Zeus-8.16928722.pdf";